/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ProductPositionFragmentDoc } from "../../product-positions/graphql/fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateProductPositionInput = {
  configurationKey?: string | null
  dimensioning?: ExternalDimensioningResultInput | null
  displayPosition?: string | null
  id: string
  isAlternative?: boolean | null
  label?: string | null
  parent?: JsonapiRelationshipData | null
  position?: number | null
  price?: number | null
  priceGroup?: string | null
  quantity: number
  references?: Array<ProductPositionInstallationReferenceInput> | null
  remark?: string | null
  variantKey: string
}

export type ExternalDimensioningResultInput = {
  dllVersion?: string | null
  environmentalVars?: any
  language?: string | null
  supplementaryText?: Array<ExternalDimensioningSupplementaryTextInput> | null
  technicalData?: Array<ExternalDimensioningTechnicalDataInput> | null
  technicalInput?: Array<ExternalDimensioningTechnicalInputInput> | null
  transactionId: string
  transferData?: ExternalDimensioningTransferDataInput | null
  variantKeyData?: any
}

export type ExternalDimensioningSupplementaryTextInput = {
  text: string
}

export type ExternalDimensioningTechnicalDataInput = {
  content?: any
  dllVersion?: string | null
  header?: Array<string> | null
  summary?: string | null
  type?: string | null
}

export type ExternalDimensioningTechnicalInputInput = {
  label?: string | null
  name: string
  unit?: string | null
  userSelected: boolean
  value?: any
}

export type ExternalDimensioningTransferDataInput = {
  origin?: string | null
}

export type JsonapiRelationshipData = {
  id: string
  type: string
}

export type ProductPositionInstallationReferenceInput = {
  id: string
  permalink: string
  position: number
  title?: string | null
}

export type CreateFavoriteMutationVariables = Exact<{
  input: Types.CreateProductPositionInput
}>

export type CreateFavoriteMutation = {
  __typename: "Mutation"
  productPosition: {
    __typename: "ProductPosition"
    id: string
    label?: string | null
    variantKey: string
    configurationKey?: string | null
    remark?: string | null
    quantity: number
    position: number
    displayPosition?: string | null
    isAlternative?: boolean | null
    price?: number | null
    priceGroup?: string | null
    hasClarificationRequest?: boolean | null
    references?: Array<{
      __typename: "ProductPositionInstallationReference"
      id: string
      title?: string | null
      permalink: string
      position: number
    }> | null
    addons?: Array<{
      __typename: "ProductPositionAddon"
      id: string
      variantKey: string
      parentProductType: string
    }> | null
    dimensioning?: {
      __typename: "ExternalDimensioningResult"
      transactionId: string
      environmentalVars?: Array<any> | null
      variantKeyData?: any
      dllVersion?: string | null
      language?: string | null
      technicalData?: Array<
        | {
            __typename: "ExternalDimensioningTechnicalDataDllVersion"
            dllVersion: string
          }
        | {
            __typename: "ExternalDimensioningTechnicalDataTable"
            header?: Array<string> | null
            content?: any
            summary?: string | null
            type?: string | null
          }
      > | null
      technicalInput?: Array<{
        __typename: "ExternalDimensioningTechnicalInput"
        name: string
        label?: string | null
        unit?: string | null
        value?: any
        userSelected: boolean
      }> | null
      supplementaryText?: Array<{
        __typename: "ExternalDimensioningSupplementaryText"
        text: string
      }> | null
      transferData?: {
        __typename: "ExternalDimensioningTransferData"
        origin?: string | null
      } | null
    } | null
  }
}

export type BatchCreateFavoritesMutationVariables = Exact<{
  input:
    | Array<Types.CreateProductPositionInput>
    | Types.CreateProductPositionInput
}>

export type BatchCreateFavoritesMutation = {
  __typename: "Mutation"
  productPositions: Array<{
    __typename: "ProductPosition"
    id: string
    label?: string | null
    variantKey: string
    configurationKey?: string | null
    remark?: string | null
    quantity: number
    position: number
    displayPosition?: string | null
    isAlternative?: boolean | null
    price?: number | null
    priceGroup?: string | null
    hasClarificationRequest?: boolean | null
    references?: Array<{
      __typename: "ProductPositionInstallationReference"
      id: string
      title?: string | null
      permalink: string
      position: number
    }> | null
    addons?: Array<{
      __typename: "ProductPositionAddon"
      id: string
      variantKey: string
      parentProductType: string
    }> | null
    dimensioning?: {
      __typename: "ExternalDimensioningResult"
      transactionId: string
      environmentalVars?: Array<any> | null
      variantKeyData?: any
      dllVersion?: string | null
      language?: string | null
      technicalData?: Array<
        | {
            __typename: "ExternalDimensioningTechnicalDataDllVersion"
            dllVersion: string
          }
        | {
            __typename: "ExternalDimensioningTechnicalDataTable"
            header?: Array<string> | null
            content?: any
            summary?: string | null
            type?: string | null
          }
      > | null
      technicalInput?: Array<{
        __typename: "ExternalDimensioningTechnicalInput"
        name: string
        label?: string | null
        unit?: string | null
        value?: any
        userSelected: boolean
      }> | null
      supplementaryText?: Array<{
        __typename: "ExternalDimensioningSupplementaryText"
        text: string
      }> | null
      transferData?: {
        __typename: "ExternalDimensioningTransferData"
        origin?: string | null
      } | null
    } | null
  }>
}

export const CreateFavoriteDocument = gql`
  mutation CreateFavorite($input: CreateProductPositionInput!) {
    productPosition: createFavoritesProductPosition(input: $input)
      @rest(
        type: "ProductPosition"
        method: "POST"
        path: "/project-list/favorites/project-positions"
        bodySerializer: "productPosition"
      ) {
      ...ProductPosition
    }
  }
  ${ProductPositionFragmentDoc}
`
export type CreateFavoriteMutationFn = Apollo.MutationFunction<
  CreateFavoriteMutation,
  CreateFavoriteMutationVariables
>

/**
 * __useCreateFavoriteMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteMutation, { data, loading, error }] = useCreateFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFavoriteMutation,
    CreateFavoriteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateFavoriteMutation,
    CreateFavoriteMutationVariables
  >(CreateFavoriteDocument, options)
}
export type CreateFavoriteMutationHookResult = ReturnType<
  typeof useCreateFavoriteMutation
>
export type CreateFavoriteMutationResult =
  Apollo.MutationResult<CreateFavoriteMutation>
export type CreateFavoriteMutationOptions = Apollo.BaseMutationOptions<
  CreateFavoriteMutation,
  CreateFavoriteMutationVariables
>
export const BatchCreateFavoritesDocument = gql`
  mutation BatchCreateFavorites($input: [CreateProductPositionInput!]!) {
    productPositions: batchCreateFavoritesProductPositions(input: $input)
      @rest(
        type: "ProductPosition"
        method: "POST"
        path: "/project-list/favorites/project-positions"
        bodySerializer: "productPosition"
      ) {
      ...ProductPosition
    }
  }
  ${ProductPositionFragmentDoc}
`
export type BatchCreateFavoritesMutationFn = Apollo.MutationFunction<
  BatchCreateFavoritesMutation,
  BatchCreateFavoritesMutationVariables
>

/**
 * __useBatchCreateFavoritesMutation__
 *
 * To run a mutation, you first call `useBatchCreateFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateFavoritesMutation, { data, loading, error }] = useBatchCreateFavoritesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateFavoritesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchCreateFavoritesMutation,
    BatchCreateFavoritesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BatchCreateFavoritesMutation,
    BatchCreateFavoritesMutationVariables
  >(BatchCreateFavoritesDocument, options)
}
export type BatchCreateFavoritesMutationHookResult = ReturnType<
  typeof useBatchCreateFavoritesMutation
>
export type BatchCreateFavoritesMutationResult =
  Apollo.MutationResult<BatchCreateFavoritesMutation>
export type BatchCreateFavoritesMutationOptions = Apollo.BaseMutationOptions<
  BatchCreateFavoritesMutation,
  BatchCreateFavoritesMutationVariables
>
